// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".precise-price-app .vueperslides--3gQHn{padding:0 3em 2em}.precise-price-app .vueperslides{overflow:hidden;margin-bottom:0;box-sizing:content-box}.precise-price-app .vueperslides__arrow svg{stroke-width:3;width:3em;color:#fff}.precise-price-app .vueperslides__fractions{color:#888;display:flex;justify-content:center;right:0;bottom:5px;position:relative;border:0;top:0;left:1.75em}.precise-price-app .vueperslides__parallax-wrapper,.precise-price-app .vueperslides__track{overflow:visible}.precise-price-app .vueperslides__bullets{top:5px}.precise-price-app .vueperslide{background-size:100%;opacity:.8}.precise-price-app .vueperslide--active{opacity:1}", ""]);
// Exports
exports.locals = {
	"vueperslides": "vueperslides--3gQHn"
};
module.exports = exports;
